import { ShieldCheck, ShieldOff } from "lucide-react";

export const UserPlanAction = ({ row, busyId, onPlanChange }) => {
  if (row.role === "admin") {
    return <span className="text-xs text-slate-400">Full access</span>;
  }
  if (row.plan === "master") {
    return (
      <button
        data-testid={`revoke-btn-${row.id}`}
        disabled={busyId === row.id}
        onClick={() => onPlanChange(row, "free")}
        className="flex items-center gap-1 border border-slate-300 px-2 py-1 text-xs font-semibold text-slate-600 hover:border-rose-300 hover:text-rose-600 disabled:opacity-40"
      >
        <ShieldOff className="h-3.5 w-3.5" /> Revoke
      </button>
    );
  }
  return (
    <button
      data-testid={`grant-btn-${row.id}`}
      disabled={busyId === row.id}
      onClick={() => onPlanChange(row, "master")}
      className="flex items-center gap-1 bg-[#1A365D] px-2 py-1 text-xs font-semibold text-white hover:bg-[#122845] disabled:opacity-40"
    >
      <ShieldCheck className="h-3.5 w-3.5" /> Grant MasterPlan
    </button>
  );
};